import Button from '../../Button/Button';
import Characteristics from '../Characteristics';
import './Description.scss';

function Description({card}) {

    return (
        <div className='description'>
            <div className='description__title'>
                Sennheiser
            </div>
            <div className='description__subtitle'>
                {card.subtitle}
            </div>
            <div className='description__text'>
                {card.text1}
            </div>
            <div className='description__text'>
                {card.text2}
            </div>
            <Characteristics props= {card.posibilities}/>
            <div className='description__buttons'>
                <Button text="купить" href={card.href}/>
                <Button text="видеообзор" href={card.video}/>
            </div>  
        </div>
    )
}
export default Description;